import {useEffect, useRef} from 'react';

import {UWM_ANALYTICS_ACTIONS} from './consts/analytics';

type TrackAnalytics = (eventType: string, params?: Record<string, unknown>) => void;

interface UsePopupAnalyticsParams {
    modalType: string;
    track: TrackAnalytics;
    isVisible?: boolean;
}

export const usePopupAnalytics = ({modalType, track, isVisible = true}: UsePopupAnalyticsParams): void => {
    const trackRef = useRef(track);
    trackRef.current = track;

    useEffect(() => {
        if (!isVisible || !modalType) return;

        // Empty eventType → no rumActionName → the host records a clean `VISIBLE`/`HIDDEN` action.
        trackRef.current('', {action: UWM_ANALYTICS_ACTIONS.VISIBLE, modalType});

        return () => {
            trackRef.current('', {action: UWM_ANALYTICS_ACTIONS.HIDDEN, modalType});
        };
    }, [modalType, isVisible]);
};
